import { useState } from "react";
import { tiposIndividuo, estadosFitossanitarios, classesRisco, recomendacoesManejo, statusRevisaoList } from "@/mocks/cta";

interface TreeFiltersProps {
  onFilter: (filters: Record<string, string>) => void;
}

export default function TreeFilters({ onFilter }: TreeFiltersProps) {
  const [search, setSearch] = useState("");
  const [tipo, setTipo] = useState("");
  const [fito, setFito] = useState("");
  const [risco, setRisco] = useState("");
  const [recomendacao, setRecomendacao] = useState("");
  const [statusRevisao, setStatusRevisao] = useState("");
  const [showFilters, setShowFilters] = useState(false);

  const applyFilters = () => {
    onFilter({
      search: search.toLowerCase(),
      tipo,
      fito,
      risco,
      recomendacao,
      statusRevisao,
    });
  };

  const clearFilters = () => {
    setSearch("");
    setTipo("");
    setFito("");
    setRisco("");
    setRecomendacao("");
    setStatusRevisao("");
    onFilter({});
  };

  const hasFilters = search || tipo || fito || risco || recomendacao || statusRevisao;

  return (
    <div className="bg-white rounded-card border border-background-200 p-4">
      <div className="flex items-center gap-2">
        <div className="flex-1 relative">
          <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
          <input
            type="text"
            placeholder="Buscar por código CTA, espécie, logradouro ou bairro..."
            value={search}
            onChange={(e) => { setSearch(e.target.value); applyFilters(); }}
            className="w-full pl-9 pr-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 bg-background-50"
          />
        </div>
        <button
          onClick={() => setShowFilters(!showFilters)}
          className={`btn-outline text-xs px-3 py-2 cursor-pointer ${showFilters ? "border-primary-400 text-primary-600 bg-primary-50" : ""}`}
        >
          <i className="ri-filter-3-line"></i>
          Filtros
          {hasFilters && (
            <span className="ml-1 w-4 h-4 rounded-full bg-primary-500 text-white text-[10px] flex items-center justify-center">
              {[search ? 1 : 0, tipo ? 1 : 0, fito ? 1 : 0, risco ? 1 : 0, recomendacao ? 1 : 0, statusRevisao ? 1 : 0].reduce((a, b) => a + b, 0)}
            </span>
          )}
        </button>
        {hasFilters && (
          <button onClick={clearFilters} className="btn-outline text-xs px-3 py-2 cursor-pointer">
            <i className="ri-close-line"></i>
            Limpar
          </button>
        )}
      </div>

      {showFilters && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-3 pt-3 border-t border-background-200">
          <div>
            <label className="text-xs text-foreground-500 mb-1 block">Tipo de Indivíduo</label>
            <select value={tipo} onChange={(e) => { setTipo(e.target.value); applyFilters(); }}
              className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50">
              <option value="">Todos</option>
              {tiposIndividuo.map((t) => (
                <option key={t} value={t}>{t}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="text-xs text-foreground-500 mb-1 block">Estado Fitossanitário</label>
            <select value={fito} onChange={(e) => { setFito(e.target.value); applyFilters(); }}
              className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50">
              <option value="">Todos</option>
              {estadosFitossanitarios.map((e) => (
                <option key={e} value={e}>{e.charAt(0).toUpperCase() + e.slice(1)}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="text-xs text-foreground-500 mb-1 block">Classe de Risco</label>
            <select value={risco} onChange={(e) => { setRisco(e.target.value); applyFilters(); }}
              className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50">
              <option value="">Todas</option>
              {classesRisco.map((r) => (
                <option key={r} value={r}>{r.charAt(0).toUpperCase() + r.slice(1)}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="text-xs text-foreground-500 mb-1 block">Recomendação de Manejo</label>
            <select value={recomendacao} onChange={(e) => { setRecomendacao(e.target.value); applyFilters(); }}
              className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50">
              <option value="">Todas</option>
              {recomendacoesManejo.map((r) => (
                <option key={r} value={r}>{r}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="text-xs text-foreground-500 mb-1 block">Status de Revisão</label>
            <select value={statusRevisao} onChange={(e) => { setStatusRevisao(e.target.value); applyFilters(); }}
              className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50">
              <option value="">Todos</option>
              {statusRevisaoList.map((s) => (
                <option key={s} value={s}>{s.charAt(0).toUpperCase() + s.slice(1)}</option>
              ))}
            </select>
          </div>
        </div>
      )}
    </div>
  );
}